'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const [e2ee, setE2ee] = useState(false);
  const [sharedPassphrase, setSharedPassphrase] = useState(randomString(64));
  const [usePassword, setUsePassword] = useState(false);
  const [roomPassword, setRoomPassword] = useState('');
  const [useLobby, setUseLobby] = useState(false);
  const [customRoomName, setCustomRoomName] = useState('');

  const startMeeting = () => {
    const roomId = customRoomName.trim() || generateRoomId();
    let url = `/rooms/${roomId}`;
    
    const params = new URLSearchParams();
    if (usePassword && roomPassword) {
      params.append('pwd', btoa(roomPassword));
    }
    if (useLobby) {
      params.append('lobby', 'true');
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    if (e2ee) {
      url += `#${encodePassphrase(sharedPassphrase)}`;
    }
    
    router.push(url);
  };

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>Opt-Con Meet</h1>
          <h2 style={{ fontWeight: 'normal', opacity: 0.8 }}>
            Sichere Videokonferenzen für Ihr Unternehmen
          </h2>
        </div>

        <div className={styles.tabContent}>
          {/* Raumname */}
          <div style={{ marginBottom: '1.5rem', width: '100%' }}>
            <label htmlFor="roomName" style={{ display: 'block', marginBottom: '0.5rem', color: '#888' }}>
              Raumname (optional)
            </label>
            <input
              id="roomName"
              type="text"
              placeholder="z.B. projekt-meeting"
              value={customRoomName}
              onChange={(ev) => setCustomRoomName(ev.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-'))}
              style={{
                width: '100%',
                padding: '0.75rem',
                borderRadius: '8px',
                border: '1px solid #333',
                backgroundColor: '#16213e',
                color: '#fff',
                fontSize: '1rem',
              }}
            />
          </div>

          <button
            style={{ marginTop: '0.5rem', fontSize: '1.1rem', padding: '0.75rem 2rem', width: '100%' }}
            className="lk-button"
            onClick={startMeeting}
          >
            Meeting starten
          </button>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '2rem' }}>
            {/* Warteraum */}
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center' }}>
              <input
                id="use-lobby"
                type="checkbox"
                checked={useLobby}
                onChange={(ev) => setUseLobby(ev.target.checked)}
              />
              <label htmlFor="use-lobby">🚪 Warteraum aktivieren (Teilnehmer müssen freigegeben werden)</label>
            </div>

            {/* Raumpasswort */}
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center' }}>
              <input
                id="use-password"
                type="checkbox"
                checked={usePassword}
                onChange={(ev) => setUsePassword(ev.target.checked)}
              />
              <label htmlFor="use-password">🔐 Raumpasswort verwenden</label>
            </div>
            {usePassword && (
              <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center', marginLeft: '2rem' }}>
                <input
                  id="room-password"
                  type="text"
                  placeholder="Passwort eingeben"
                  value={roomPassword}
                  onChange={(ev) => setRoomPassword(ev.target.value)}
                  style={{
                    padding: '0.5rem',
                    borderRadius: '5px',
                    border: '1px solid #333',
                    backgroundColor: '#16213e',
                    color: '#fff',
                  }}
                />
              </div>
            )}

            {/* E2EE */}
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center' }}>
              <input
                id="use-e2ee"
                type="checkbox"
                checked={e2ee}
                onChange={(ev) => setE2ee(ev.target.checked)}
              />
              <label htmlFor="use-e2ee">🔒 Ende-zu-Ende-Verschlüsselung aktivieren</label>
            </div>
            {e2ee && (
              <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center', marginLeft: '2rem' }}>
                <label htmlFor="passphrase">Passphrase:</label>
                <input
                  id="passphrase"
                  type="password"
                  value={sharedPassphrase}
                  onChange={(ev) => setSharedPassphrase(ev.target.value)}
                  style={{
                    padding: '0.5rem',
                    borderRadius: '5px',
                    border: '1px solid #333',
                    backgroundColor: '#16213e',
                    color: '#fff',
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </main>

      <footer data-lk-theme="default">
        © 2025 Opt-Con UG | Sichere Kommunikation
      </footer>
    </>
  );
}
